import React from "react";

const BTNCLOHistoryContent = () => {
  return (
    <div className="p-8">
      <div className="space-y-8">
        {/* Background Section */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">
            Latar Belakang Pembentukan
          </h2>
          <div className="bg-base-100 rounded-lg p-6 space-y-4">
            <p className="text-base-content/70 leading-relaxed">
              Saat ini, ada istilah global citizens dimana masyarakat dapat
              bersosialisasi dengan siapapun tanpa batasan-batasan pada zaman
              modern ini, sedangkan interaksi yang dilakukan oleh masyarakat
              pada zaman dahulu terbatas.
            </p>
            <p className="text-base-content/70 leading-relaxed">
              Dengan berkembangnya peradaban manusia dan kejahatan yang lebih
              pesat, terdapat peran polisi di masing-masing negara untuk
              menangani kejahatan-kejahatan yang muncul. Namun jika
              kejahatan-kejahatan tersebut tidak ditangani atau terdapat
              ketidakmampuan pihak keamanan untuk menangani permasalahan
              kejahatan, maka hal tersebut dapat meruntuhkan ketahanan negara.
            </p>
          </div>
        </div>

        {/* Formation Process */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Proses Pembentukan</h2>
          <div className="bg-base-100 rounded-lg p-6">
            <p className="text-base-content/70 leading-relaxed">
              Muncul gagasan tentang bagaimana mengelola perbatasan dalam
              kejahatan transnasional. Diperlukan adanya kemudahan akses dan
              koordinator di wilayah perbatasan, maka dibentuklah BTNCLO (Border
              Transnational Crime Liaison Officer).
            </p>
          </div>
        </div>

        {/* Legal Foundation */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Dasar Hukum</h2>
          <div className="bg-base-100 rounded-lg p-6">
            <div className="flex items-start gap-4">
              <div className="bg-primary rounded-full w-12 h-12 flex items-center justify-center flex-shrink-0">
                <span className="text-2xl">📜</span>
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-lg mb-2">
                  Keputusan Kepala Kepolisian Republik Indonesia
                </h3>
                <div className="bg-base-200 rounded-lg p-4 mb-4">
                  <p className="font-medium">
                    Nomor: <span className="font-bold">1666 tahun 2024</span>
                  </p>
                  <p className="font-medium">
                    Tanggal:{" "}
                    <span className="font-bold">30 September 2024</span>
                  </p>
                </div>
                <p className="text-base-content/70 leading-relaxed">
                  Tentang Perwira Penghubung Penanggulangan Kejahatan
                  Transnasional di Wilayah Perbatasan (Border Transnational
                  Crime Liaison Officer).
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Timeline Visual */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Timeline Pembentukan</h2>
          <div className="space-y-6">
            <div className="flex items-start gap-6">
              <div className="bg-primary rounded-full w-16 h-16 flex items-center justify-center flex-shrink-0">
                <span className="text-2xl">🌐</span>
              </div>
              <div className="bg-base-100 rounded-lg p-6 flex-1">
                <h3 className="font-semibold text-lg mb-2">
                  Era Global Citizens
                </h3>
                <p className="text-base-content/70 leading-relaxed">
                  Masyarakat dapat bersosialisasi tanpa batasan geografis,
                  menciptakan tantangan baru dalam penanggulangan kejahatan
                  transnasional.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-6">
              <div className="bg-secondary rounded-full w-16 h-16 flex items-center justify-center flex-shrink-0">
                <span className="text-2xl">⚖️</span>
              </div>
              <div className="bg-base-100 rounded-lg p-6 flex-1">
                <h3 className="font-semibold text-lg mb-2">
                  Identifikasi Kebutuhan
                </h3>
                <p className="text-base-content/70 leading-relaxed">
                  Diperlukan koordinator khusus di wilayah perbatasan untuk
                  menangani kejahatan transnasional yang semakin kompleks.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-6">
              <div className="bg-accent rounded-full w-16 h-16 flex items-center justify-center flex-shrink-0">
                <span className="text-2xl">📋</span>
              </div>
              <div className="bg-base-100 rounded-lg p-6 flex-1">
                <h3 className="font-semibold text-lg mb-2">
                  30 September 2024
                </h3>
                <p className="text-base-content/70 leading-relaxed">
                  Pengesahan Keputusan Kepala Kepolisian RI No. 1666/2024
                  tentang pembentukan BTNCLO di 13 Polda wilayah perbatasan.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BTNCLOHistoryContent;
